import type {
  UserDTO,
} from 'dtos/userDTO';

export type ReportState = 'Ready' | 'InProgress' | 'Failed';

export const readableReportState: Record<ReportState, string> = {
  Ready: 'Ready',
  InProgress: 'In Progress',
  Failed: 'Failed',
};

export type RunKind = 'report' | 'statement';

export type RunOutputSource =
  | { kind: 'report'; reportId: number }
  | { kind: 'statement'; bulkPatientStatementId: number };

export type SummaryTone = 'Default' | 'Warning' | 'Danger';

// ReportOutputDTO has no title/date/user/state, so the opener passes them.
// NOTE: if the backend adds these to ReportOutputDTO later, read them from the API and drop `header`.
export type RunHeader = {
  title: string;
  createdOn?: string;
  createdBy?: UserDTO;
  state?: ReportState;
};

export type RunOutputPanelInfo = RunOutputSource & { header: RunHeader };

// What useRunOutput returns after normalizing ReportOutputDTO.
export type RunOutputFile = {
  reportOutputFileId: number | null;
  fileName: string;
  contentType: string;
  sizeBytes: number | null;
  itemCount: number | null;
  canPreview: boolean;
};

export type RunOutputSummaryItem = {
  label: string;
  value: string;
  tone: SummaryTone;
};

export type RunOutput = {
  message: string | null;
  summary: RunOutputSummaryItem[];
  settings: Record<string, string>;
  files: RunOutputFile[];
};
